import { siteConfig } from "@/mocks/site";
import ScrollToTop from "@/components/base/ScrollToTop";
import PageMeta from "@/components/base/PageMeta";
import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import CategoryNav from "./components/CategoryNav";
import HotRecommend from "./components/HotRecommend";
import LatestRelease from "./components/LatestRelease";
import ArticleSection from "./components/ArticleSection";
import Footer from "@/components/feature/Footer";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: siteConfig.name,
  url: siteConfig.url,
  description: siteConfig.description,
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${siteConfig.url}/search?q={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: siteConfig.name,
  url: siteConfig.url,
  description: siteConfig.description,
  address: {
    "@type": "PostalAddress",
    streetAddress: "建国路88号SOHO现代城A座18层",
    addressLocality: "北京",
    addressRegion: "北京",
    postalCode: "100022",
    addressCountry: "CN",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "400-888-6666",
    contactType: "customer service",
    availableLanguage: "Chinese",
  },
};

export default function Home() {
  return (
    <>
      <PageMeta
        title="蜜桃影视 - 热门影视资源在线观看平台"
        description="蜜桃影视是您发现热门电影、电视剧、综艺节目的首选平台，海量高清资源随时在线观看，支持多终端播放，让您随时随地享受优质影视娱乐体验。蜜桃影视致力于为用户提供流畅、清晰、丰富的影视内容服务。"
        keywords="蜜桃影视,蜜桃影视在线观看,蜜桃影视高清资源,蜜桃影视电影推荐,蜜桃影视电视剧,蜜桃影视最新上线,热门影视平台"
        canonicalUrl={siteConfig.url}
        schemaObjects={[homeSchema, orgSchema]}
      />

      <ScrollToTop />
      <Navbar />

      <main>
        <article>
          <Hero />
          <CategoryNav />
          <HotRecommend />
          <LatestRelease />
          <ArticleSection />
        </article>
      </main>

      <Footer />
    </>
  );
}